export enum CustomServerStorage {
  LAST_SERVER = "last_server",
  CUSTOM_SERVERS = "custom_servers",
}
